'use strict';
import { ValueLookups, ModelValue } from 'marionette.binding';
import Forms from 'marionette.forms';
import moment from 'moment';

import ContactView from 'base/views/contacts';
import AttachmentView from 'base/views/attachments';
import { CostCentreDropdown } from 'transactions/views/costcentre_dropdown';
import AccountDropdown from 'transactions/views/account_dropdown';
import ImageListView from 'offers/views/images';
import LedgerCodeList from 'base/views/ledger';

import IconCollection from 'offers/collections/icons';

class MomentLookup extends ModelValue {
  intFormat() {
    return 'DD/MM/YYYY HH:mm:ss';
  }

  get() {
    return moment(super.get(), this.intFormat()).format(this.format());
  }

  set(value, args) {
    let date = moment(super.get(), this.intFormat());
    date = this.save(date, value);
    super.set(date.format(this.intFormat()), args);
  }
}

class DateLookup extends MomentLookup {
  format() {
    return 'DD/MM/YYYY';
  }

  save(date, value) {
    value = value.split('/');

    date.set({
      year: value[2],
      month: value[1],
      date: value[0]
    });

    return date;
  }
}

class TimeLookup extends MomentLookup {
  format() {
    return 'HH:mm';
  }

  save(date, value) {
    value = value.split(':');

    date.set({
      minute: value[1],
      hour: value[0]
    });

    return date;
  }
}

ValueLookups['date'] = DateLookup;
ValueLookups['time'] = TimeLookup;

export default Forms.FormLayoutView.extend({
  template: require('../templates/form.html'),

  renderError(err) {
    if (err.length == 0) return;
    return '<ul class="errorlist"><li>' + err.join('</li><li>') + '</li></ul>';
  },

  regions: {
    names: '#name-hook',
    costcentres: '#account-hook',
    settlement: '#settlement-hook',
    attachments: '#attachments-hook',
    images: '#images-hook',
    ledger: '#ledger-hook'
  },

  ui: {
    title: '#id_title',
    description: '#id_description',
    gift_aid: '#id_gift_aid',
    consent_required: '#id_consent_required',
    start_date: '#id_start_date',
    start_time: '#id_start_time',
    end_date: '#id_end_date',
    end_date_null: '#id_end_date_null',
    total_items: '.total_items',
    item_cost: '.item_cost',
    minimum_amount: '#minimum_amount',
    fixed_cost: '#fixed_cost',
    buy_at_once: '.buy_at_once',
    exact_quantity: '#quantity',
    minimum_quantity: '#id_minimum_quantity',
    maximum_quantity: '#id_maximum_quantity',
    recurring: '.recurring',
    //"variations": ".variations",
    published: '.published',
    //"variation_block": ".variation-block",
    item_cost_block: '.itemCostBlock',
    tax: '#id_tax',
    submit: '#id_submit',
    mandatory_offer: '#mandatory_offer',
    total_number_of_items: '#total_number_of_items',
    variable_quantity_block: '.variable_quantity_block',
    variable_amount_block: '.variable_amount_block'
  },

  bindings: {
    // ==> Select Account
    // (account value is handled by widget)
    'value @ui.tax': 'tax',
    // (ledger code value is handled by widget)

    // ==> Select settlement Account
    // (account value is handled by widget)

    // ==> Offer Details
    // --> Basic Details
    'value @ui.title': 'title',
    'value @ui.description': 'description',

    // --> Checkboxes
    'checked @ui.gift_aid': 'gift_aid',
    'checked @ui.consent_required': 'consent_required',
    'checked @ui.mandatory_offer': 'mandatory_offer',

    // ==> Offer Cost
    // --> Total number of items you have
    'checked @ui.total_items': 'unlimited_quantity',
    'value @ui.total_number_of_items': 'available',

    // --> Cost of item
    'value @ui.fixed_cost': 'amount',
    'value @ui.minimum_amount': 'minimum_amount',
    'checked @ui.item_cost': 'unspecified',

    //   > How many can a parent purchase at the same time
    'value @ui.exact_quantity': 'minimum_quantity',
    'value @ui.minimum_quantity': 'minimum_quantity',
    'value @ui.maximum_quantity': 'maximum_quantity',
    'checked @ui.buy_at_once': 'quantity_setting',

    // ==> Offer Dates
    'value @ui.start_time': 'start_date__time',
    'value @ui.start_date': 'start_date__date',
    'value @ui.end_date': 'end_date',
    'checked @ui.recurring': 'recurring',
    'checked @ui.end_date_null': 'end_date__isnull',
    'disabled @ui.end_date': 'end_date__isnull',

    // ==> Variations
    //"checked @ui.variations": "variations_on",

    // ==> Publishing
    'checked @ui.published': 'is_active'
  },

  modelEvents: {
    'change:unspecified': 'costTypeChange',
    'change:minimum_quantity': 'updateMaximumQuanity',
    'change:quantity_setting': 'updateQuantitySetting',
    'sync': 'render',
    'error': 'onError',
    'saved': 'saved'
  },

  saved() {
    window.messages.add('Offer updated', 'success');
  },

  onError() {
    window.messages.add('There was a problem saving the offer', 'error');
  },

  updateMaximumQuanity() {
    if (this.model.get('quantity_setting') == 'exact') {
      this.model.set('maximum_quantity', this.model.get('minimum_quantity'));
    }
  },

  updateQuantitySetting() {
    if (this.model.get('quantity_setting') == 'minimum') {
      this.ui.variable_quantity_block.show();
    } else {
      this.ui.variable_quantity_block.hide();
    }
    this.updateMaximumQuanity();
  },

  costTypeChange() {
    if (this.model.get('unspecified') == 0) {
      this.ui.item_cost_block.show();
      this.ui.variable_amount_block.hide();
    } else {
      this.ui.item_cost_block.hide();
      this.ui.variable_amount_block.show();
    }
  },

  triggers: {
    'click @ui.submit': 'submit'
  },

  onSubmit() {
    this.ui.submit.text('Posting...').prop('disabled', 'disabled');
    this.saving = true;
    this.model.save(
      {},
      {
        success: () => {
          document.location.href = `/joinos/v2/offers/${
            this.model.id
          }/?saved=true`;
        },
        error: data => {
          this.errors = data.responseJSON;
          this.saving = false;
        }
      }
    );
    this.model.save();
  },

  onRender() {
    this.$('.date').datepicker({
      dateFormat: 'dd/mm/yyyy'
    });

    if (this._skipRender()) {
      return;
    }
    if (this.model.get('id') === 'new') {
      this.model.set('start_date', moment().format('DD/MM/YYYY HH:mm:ss'));
    }

    this.showChildView(
      'costcentres',
      new CostCentreDropdown({
        model: this.model
      })
    );
    this.showChildView(
      'settlement',
      new AccountDropdown({
        model: this.model
      })
    );
    this.showChildView(
      'ledger',
      new LedgerCodeList({
        model: this.model
      })
    );

    const contactView = new ContactView({
      filter: this.model.get('contacts'),
      query: { contact_type: 'pupil' }
    });
    this.showChildView('names', contactView);

    const attachmentView = new AttachmentView({
      collection: this.model.get('documents')
    });
    this.showChildView('attachments', attachmentView);

    let ico = new IconCollection();
    let imageView = new ImageListView({
      collection: ico,
      model: this.model,
      mode: 'display'
    });
    ico.fetch();
    this.showChildView('images', imageView);

    this.startBindings();
  },

  initialize() {
    this.errors = {};
    this.saving = false;
  },

  _skipRender() {
    return this.model.state != Forms.ModelState.Synced;
  }
});



// WEBPACK FOOTER //
// ./offers/views/editor.js